import { c as _c } from "react/compiler-runtime";
import Image, { type ImageProps } from 'next/image';
export { IMAGE_SIZES } from './sizes';
type CdnImageProps = Omit<ImageProps, 'quality'> & {
  quality?: number;
};
export const CdnImage = t0 => {
  const $ = _c(12);
  let isSvg;
  let priority;
  let props;
  let quality;
  let t1;
  let t2;
  if ($[0] !== t0) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        quality: t3,
        priority: t4,
        ...t5
      } = t0;
      priority = t4;
      props = t5;
      quality = t3 === undefined ? 80 : t3;
      let src = "";
      if (typeof props.src === "string") {
        src = props.src;
      } else {
        if (typeof props.src === "object" && props.src !== null) {
          if ("src" in props.src) {
            src = props.src.src;
          } else {
            if ("default" in props.src) {
              src = (props.src as {
                default: {
                  src: string;
                };
              }).default.src;
            }
          }
        }
      }
      if (!src) {
        t2 = null;
        break bb0;
      }
      isSvg = src.toLowerCase().endsWith(".svg");
      t1 = src.includes("nerdwallet.com") || src.includes("nerdwallet.biz");
    }
    $[0] = t0;
    $[1] = isSvg;
    $[2] = priority;
    $[3] = props;
    $[4] = quality;
    $[5] = t1;
    $[6] = t2;
  } else {
    isSvg = $[1];
    priority = $[2];
    props = $[3];
    quality = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  const isNerdWalletImage = t1;
  const shouldSkipOptimization = isSvg || !isNerdWalletImage;
  const t3 = shouldSkipOptimization ? true : props.unoptimized;
  let t4;
  if ($[7] !== priority || $[8] !== props || $[9] !== quality || $[10] !== t3) {
    t4 = <Image {...props} alt={props.alt} quality={quality} priority={priority} unoptimized={t3} />;
    $[7] = priority;
    $[8] = props;
    $[9] = quality;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};